import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Dropdown, Icon, Input } from 'semantic-ui-react';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';

class SearchMultiUnits extends Component {
  static propTypes = {
    searchOnChange: PropTypes.func,
    searchOnSubmit: PropTypes.func.isRequired,
    searchValue: PropTypes.string.isRequired,
    statusOnChange: PropTypes.func,
    statusOptions: PropTypes.arrayOf(PropTypes.shape({
      text: PropTypes.string,
      value: PropTypes.string,
    })),
    statusValue: PropTypes.string,
    multiFilter: PropTypes.bool,
    t: PropTypes.func,
  }
  static getPropsToState = (props) => {
    const searchValue = props.searchValue || '';
    const statusValue = props.statusValue || '';
    return {
      searchValue,
      statusValue,
    };
  }
  constructor(props) {
    super(props);
    const state = SearchMultiUnits.getPropsToState(props);
    this.state = state;
  }
  componentWillReceiveProps(nextProps) {
    const state = SearchMultiUnits.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  handleSearchOnChange = (e, data) => {
    this.setState({ searchValue: data.value }, () => {
      if (this.props.searchOnChange) {
        this.props.searchOnChange(e, data);
      }
    });
  }
  handleSearchSubmit = (e) => {
    e.preventDefault();
    this.props.searchOnSubmit(this.state.searchValue);
  }
  handleStatusOnChange = (e, data) => {
    this.setState({ searchValue: data.value }, () => {
      if (this.props.statusOnChange) {
        this.props.statusOnChange(e, data);
      }
    });
  }
  render() {
    const { searchValue, statusValue } = this.state;
    const { multiFilter } = this.props;
    return (
      <form onSubmit={this.handleSearchSubmit}>
        <Input
          className="multi-edit-search"
          icon={
            <Icon
              circular
              color="teal"
              inverted
              link
              name="search"
              onClick={this.handleSearchSubmit}
              title="Search"
            />
          }
          label={
            !multiFilter &&
            <Dropdown
              basic
              onChange={this.handleStatusOnChange}
              options={this.props.statusOptions}
              selectOnBlur={false}
              value={statusValue}
            />
          }
          onChange={this.handleSearchOnChange}
          placeholder={this.props.t('Search...', { ns: TRANSLATION_FILES.translation })}
          value={searchValue}
        />
      </form>
    );
  }
}

export default withTranslation(namespaces)(SearchMultiUnits);



// WEBPACK FOOTER //
// ./src/components/MultiUnits/SearchMultiUnits.jsx